import GridContainer from '@deltek/specification-client/core/Surfaces/GridContainer'
import GridItem from '@deltek/specification-client/core/Surfaces/GridItem'
import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import { Button, Divider } from '@material-ui/core'
import { makeStyles, Theme } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import React from 'react'

import { PickerResponse } from '@deltek/specification-client/core/Widgets/Filestack/FilestackButton'
import clsx from 'clsx'
import { ExecutionResult } from 'graphql'
import { ImportDocumentRow } from '../ImportDocuments/ImportDocumentRow'

const useStyles = makeStyles((theme: Theme) => ({
    appHeader: {
        color: theme.palette.common.white,
        backgroundColor: theme.palette.grey[900],
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        position: 'absolute',
        zIndex: 1,
        width: '100%',
        left: 0,
    },
    appHeaderContent: {
        maxWidth: '1920px',
        margin: 'auto',
        gridTemplateColumns: '2fr 7fr',
        display: 'grid',
        alignItems: 'center',
        '& h1': {
            '@media (max-width: 1025px)': {
                fontSize: pxToRem(20),
            },
        },
    },
    title: {
        padding: theme.spacing(4.25), // change this to 2.5 when BP title is finalized,
        width: pxToRem(430),
        '@media (max-width: 1025px)': {
            width: pxToRem(455),
        },
    },
    appHeaderRight: {
        width: 'auto',
        marginRight: 0,
        '& .MuiGrid-item': {
            '@media (max-width: 1025px)': {
                padding: theme.spacing(2, 0.9),
            },
        },
        '& .MuiButton-contained.Mui-disabled': {
            color: 'rgb(255 255 255 / 20%)',
            backgroundColor: 'rgb(255 255 255 / 10%)',
        },
    },
    divider: {
        backgroundColor: 'rgba(255,255,255,0.25)',
        margin: theme.spacing(1.5),
    },

    dividerHeader: {
        backgroundColor: 'rgba(255,255,255,0.25)',
        margin: theme.spacing(1.5),
        height: 40,
    },
    workspaceButton: {
        borderRadius: 100,
        fontSize: pxToRem(12),
        marginLeft: theme.spacing(0.5),
        backgroundColor: theme.palette.common.white,
        '&:hover': {
            backgroundColor: theme.palette.common.white,
            color: theme.palette.common.black,
            boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
        },
    },
}))

interface ImportBPHeaderProps {
    startImport: VoidFunction
    handleFilestackLoading?: (filestackLoading: boolean | null) => void
    handlePickerDoneTransfer?: (value: PickerResponse) => void
    showGlobalSnackbar?: (options?: any) => Promise<ExecutionResult<any>>
    isImportDisabled?: boolean
    downloadMasterSpecStyleTemplate?: () => void
}

const ImportBPHeader: React.FC<ImportBPHeaderProps> = ({
    startImport,
    handleFilestackLoading,
    handlePickerDoneTransfer,
    showGlobalSnackbar,
    isImportDisabled,
    downloadMasterSpecStyleTemplate,
}) => {
    const classes = useStyles()

    return (
        <GridContainer className={classes.appHeader}>
            <GridContainer className={classes.appHeaderContent}>
                <GridItem className={classes.title}>
                    <Typography variant="h1"></Typography>
                </GridItem>
                <GridContainer
                    direction="row"
                    alignItems="center"
                    spacing={4}
                    className={classes.appHeaderRight}
                >
                    <Divider
                        className={classes.dividerHeader}
                        orientation="vertical"
                        flexItem
                    />
                    <ImportDocumentRow
                        handleFilestackLoading={handleFilestackLoading}
                        handlePickerDoneTransfer={handlePickerDoneTransfer}
                        showGlobalSnackbar={showGlobalSnackbar}
                        isBPImport={true}
                    />{' '}
                    <Button
                        data-testid={`startImport-btn`}
                        variant="contained"
                        color="default"
                        disableElevation
                        className={clsx(
                            'btnViewAllProducts',
                            classes.workspaceButton
                        )}
                        disabled={isImportDisabled}
                        onClick={startImport}
                    >
                        Start Import
                    </Button>
                    <Button
                        data-testid={`masterSpecStyleTemplate-btn`}
                        variant="contained"
                        color="default"
                        disableElevation
                        style={{
                            marginLeft: 8,
                        }}
                        className={clsx(
                            'btnViewAllProducts',
                            classes.workspaceButton
                        )}
                        onClick={downloadMasterSpecStyleTemplate}
                    >
                        MasterSpec Style Template
                    </Button>
                </GridContainer>
            </GridContainer>
        </GridContainer>
    )
}

export default ImportBPHeader
